import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
import * as i2 from "../services/auth.service";
export class CanActivateGuard {
    constructor(router, authService) {
        this.router = router;
        this.authService = authService;
    }
    canActivate(next, state) {
        return this.checkLogging(state.url);
    }
    canActivateChild(childRoute, state) {
        return this.canActivate(childRoute, state);
    }
    canLoad(route, segments) {
        const url = `/${route.path}`;
        return this.checkLoggingForLoad(url);
    }
    checkLogging(url) {
        console.log('checkLogging - LLENDO A:', url);
        if (this.authService.isLoggedIn()) {
            console.log('checkLogging - isLoggedIn: true');
            return of(true);
        }
        console.log('checkLogging - isLoggedIn: false');
        return this.authService.tryRefreshToken().pipe(map(login => {
            console.log('checkLogging - tryRefreshToken: ', login);
            if (login)
                return true; // Refrescó correctamente
            this.authService.urlUsuarioIntentaAcceder = url;
            return this.router.parseUrl('/login');
        }), catchError(() => {
            console.log('checkLogging - catchError: ', url);
            this.authService.urlUsuarioIntentaAcceder = url;
            return of(this.router.parseUrl('/login'));
        }));
        // return new Promise<boolean>(resolve => {
        //   this.authService.tryRefreshToken().subscribe({
        //     next: () => {
        //       this.authService.urlUsuarioIntentaAcceder = url;
        //       resolve(true)
        //     },
        //     error: () => {
        //       this.authService.urlUsuarioIntentaAcceder = url
        //       // No borrar storage aquí. Solo redirigir si corresponde.
        //       if (url !== '/login') {
        //         this.router.navigate(['/login']); // opcional
        //       }
        //       resolve(false);
        //     }
        //   });
        // });
    }
    checkLoggingForLoad(url) {
        console.log('LLENDO A (canLoad):', url);
        if (this.authService.isLoggedIn())
            return true;
        return this.authService.tryRefreshToken().pipe(map(login => {
            if (login)
                return true;
            this.router.navigate(['/login']);
            return false;
        }), catchError(() => {
            this.router.navigate(['/login']);
            return of(false);
        }));
    }
}
CanActivateGuard.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CanActivateGuard_Factory() { return new CanActivateGuard(i0.ɵɵinject(i1.Router), i0.ɵɵinject(i2.AuthService)); }, token: CanActivateGuard, providedIn: "root" });
